module.exports = __webpack_public_path__ + "img/active-past5.12545d3f.jpg";